<template>
  <CFormGroup
      class="material-input-wrapper"
          v-bind="{append, prepend, validFeedback, invalidFeedback,
        tooltipFeedback, description, wrapperClasses, class: computedClasses}"
      :style="wrapperAttrs.style"
      :class="wrapperAttrs.class"
  >

    <template #input>
      <input
              v-bind="controlAttrs"
              :id="safeId"
              required
              :type="type"
              :class="inputClasses"
              :readonly="readonly || plaintext"
              :value="state"
              @input="onInput($event)"
              @change="onChange($event)"
      />
    </template>

    <template
            v-for="slot in passSlots"
            #[slot]
    >
      <slot :name="slot"></slot>
    </template>
    <template #label-after-input>
      <slot name="label">
        <label v-if="label" :for="safeId"  :class="'placeholder '">
          {{ label }}
        </label>
      </slot>
    </template>
  </CFormGroup>
</template>

<script>
  import CFormGroup from '@/coreui/form/CFormGroup.vue'
  import {inputProps as props} from '@/coreui/form/form-props'
  import * as allFormMixins from '@/coreui/form/form-mixins'
  props.whitout_decimal=Boolean;

  const { initialValue, ...mixinMap } = allFormMixins
  const mixins = Object.values(mixinMap)

  export default {
    name: 'CInput',
    slots: [
      'prepend',
      'prepend-content',
      'append-content',
      'append',
      'label-after-input',
      'valid-feedback',
      'invalid-feedback',
      'description'
    ],
    inheritAttrs: false,
    emits: ['input', 'change', 'update:value', 'update:modelValue'],
    components: {CFormGroup},
    mixins,
    props,
    data() {
      return {

        state: initialValue(this),
        syncTimeout: null
      }
    },
    mounted() {
    },
    computed: {
      passSlots () {
        return this.$options.slots.filter((s) => this.$slots[s])
      },

    },
    watch:{

    },
    methods: {
      onInput(e) {

        this.state = e.target.value
        this.$emit('input', this.state, e)
        this.$emit('update:modelValue', this.state)
        if (this.lazy === true) {
          return
        }

        clearTimeout(this.syncTimeout)
        this.syncTimeout = setTimeout(() => {
          this.$emit('update:value', this.state, e)
        }, this.lazy !== false ? this.lazy : 0)
      },
      onChange(e)
      {
        this.$emit('change', this.state, e)
        this.$emit('update:value', this.state, e)
      },

    },


  }
</script>
